import React, { useEffect, useRef } from 'react';

const HetznerServicesSection = () => {
  const services = [
    {
      title: "Cloud Migration Services",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-7 h-7 text-white">
          <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        </svg>
      ),
       gradient: "from-blue-500 to-green-500",
    colorDot: "bg-blue-400",
    listItems: [
      "AWS to Hetzner Migration",
      "Azure to Hetzner Migration",
      "Google Cloud Migration",
      "Zero-Downtime Migration"
    ],
    delay: "200ms"
    },
    {
      title: "Infrastructure Setup",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-7 h-7 text-white">
          <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z" />
        </svg>
      ),
       gradient: "from-green-500 to-blue-500",
    colorDot: "bg-blue-400",
    listItems: [
      "Server Provisioning",
      "Docker & Kubernetes Setup",
      "Network Configuration",
      "Security Hardening"
    ],
    delay: "300ms"
    },
    {
      title: "Managed Cloud Support",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-7 h-7 text-white">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
        </svg>
      ),
     gradient: "from-yellow-600 to-blue-600",
    colorDot: "bg-green-500",
    listItems: [
      "24/7 Monitoring",
      "Backup Management",
      "Performance Optimization",
      "Technical Support"
    ],
      delay: "400ms"
    }
  ];

  const benefits = [
    {
      title: "Hetzner Migration Specialists",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-8 h-8 text-white">
          <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
        </svg>
      ),
      gradient: "from-green-500 to-blue-500",
      delay: "500ms"
    },
    {
      title: "Proven Cloud Experience",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-8 h-8 text-white">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
      ),
      gradient: "from-blue-500 to-green-500",
      delay: "600ms"
    },
    {
      title: "Dedicated Technical Support",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-8 h-8 text-white">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25" />
        </svg>
      ),
      gradient: "from-green-600 to-blue-600",
      delay: "700ms"
    }
  ];

  useEffect(() => {
    const fadeElements = document.querySelectorAll('.fade-in-up');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    fadeElements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-10 ">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="text-center mb-16 fade-in-up transition-all duration-700">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Our Cloud Infrastructure Services
          </h2>
          <div className="accent-line h-1 bg-green-600 mx-auto mb-4 transition-all duration-700 ease-out w-16"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto fade-in-up transition-all duration-700 delay-100">
             At AyanshTech Solutions, we provide end-to-end cloud infrastructure services to help businesses build, migrate, manage, and optimize their hosting environments. From infrastructure planning and cloud migration to server deployment, monitoring, and ongoing support, our team ensures secure, scalable, and cost-effective solutions tailored to your business needs.

          </p>
        </div>

        {/* Services Grid */}
        <div className="grid lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group relative fade-in-up transition-all duration-700"
              style={{ transitionDelay: service.delay }}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient.replace('to-', 'to-')}/5 rounded-3xl`}></div>
              <div className="relative bg-white/80 backdrop-blur-sm rounded-3xl p-8 border border-white/50 hover:shadow-2xl transition-all duration-500">
                <div className="flex items-center mb-6">
                  <div className={`w-14 h-14 bg-gradient-to-br ${service.gradient} rounded-2xl mr-4 group-hover:scale-105 transition-transform duration-300 flex items-center justify-center`}>
                    {service.icon}
                  </div>
                  <div className={`w-2 h-2 ${service.colorDot} rounded-full`}></div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  We advise you on selecting the optimally matching Hetzner servers for your specific requirements. 
                  Our experts analyze your needs and recommend the ideal configuration.
                </p>
                <ul className="space-y-3">
                  {service.listItems.map((item, idx) => (
                    <li key={idx} className="flex items-start">
                      <div className={`w-1.5 h-1.5 ${service.colorDot.replace('bg-', 'bg-')} rounded-full mt-2 mr-3 flex-shrink-0`}></div>
                      <span className="text-gray-600">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Why Choose Section */}
        <div className="mt-20">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-gray-50 to-red-50/50 rounded-3xl"></div>
            <div className="relative p-12">
              <div className="text-center fade-in-up transition-all duration-700">
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                  Why Choose AyanshTech Solutions as Your Cloud Partner?
                </h3>
                <div className="accent-line w-0 h-1 bg-brand-primary mx-auto mb-12 transition-all duration-700 ease-out"></div>
              </div>
              
              <div className="grid md:grid-cols-3 gap-8">
                {benefits.map((benefit, index) => (
                  <div 
                    key={index}
                    className="group text-center fade-in-up transition-all duration-700"
                    style={{ transitionDelay: benefit.delay }}
                  >
                    <div className={`w-16 h-16 bg-gradient-to-br ${benefit.gradient} rounded-2xl mx-auto mb-6 group-hover:scale-105 transition-transform duration-300 flex items-center justify-center`}>
                      {benefit.icon}
                    </div>
                    <h4 className="text-lg font-bold text-gray-900 mb-4">{benefit.title}</h4>
                    <p className="text-gray-600 leading-relaxed">
                    {index === 0 &&
                        "With expertise in cloud migration, infrastructure management, and DevOps, we help businesses build secure, scalable, and cost-effective cloud environments."}

                    {index === 1 &&
                        "Our team has successfully delivered cloud infrastructure, migration, and hosting projects for businesses across various industries and requirements."}

                    {index === 2 &&
                        "We provide personalized technical support with dedicated experts who understand your business needs, ensuring fast responses and reliable assistance whenever required."}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HetznerServicesSection;